export default __webpack_public_path__ + "static/automation-robot-300fa59699f0c621416bb72b50ad8e5f.png";